import {Pipe,PipeTransform} from '@angular/core';


@Pipe({
    name: "status",
    pure:true
})
export class StatusPipe implements PipeTransform{

    transform(status: any,...args: any[]) {
        if(status == null || status == undefined) return status;
       
        if(typeof status == 'string') {
            return status.toUpperCase()=='ACTIVE'? 'Active':'Inactive';
        }

        if(typeof status == 'boolean') {
            return status == true ? 'Active' : 'Inactive'
        }
    }

}